<!--
@Author: Liao Hui
@Date:   2019-09-09T11:00:37+08:00
@Last modified by:   Liao Hui
@Last modified time: 2019-09-10T10:50:06+08:00
-->

<template>
  <div class="pg_record">
      <div class="record_frame"></div>
      <div class="close" @click="close"></div>
      <div class="copy_wrapper">
        <div class="copy" v-for="id in card_id_list" :key="id">
          <div class="card" :class="[`card_${id}`]"></div>
        </div>
      </div>
      <div class="confirm" @click="close"></div>
  </div>
</template>
<script>

export default {
    props: ['card_id_list'],
    mounted() {
      // console.log(this.msg);
    },
    methods: {
      close() {
        this.$emit('close');
      }
    }
  }
</script>
<style rel="stylesheet/stylus" lang="stylus" scoped>
  .pg_record
    width: 7.5rem;
    height: 8.56rem;
    left: 0;
    position absolute
    top 50%
    margin-top -4.75rem
    .record_frame
      position: absolute;
      width: 7.5rem;
      height: 8.12rem;
      left: 0;
      bottom: 0
      background-image url('./images/record.png')
      background-size 100% 100%
    .record
      position: absolute;
      height: auto;
      font-size: 0.30rem;
      line-height: 1;
      color: #ad0b0b;
      left: 1.54rem;
      top: 1.83rem;
    .copy_wrapper
      position: absolute;
      width: 6.14rem;
      height: .41rem;
      left: 0.68rem;
      top: 3.44rem;
      display flex
      justify-content: center
      .copy
        width: 1.38rem;
        height: 2.60rem;
        background-image url('./images/card-frame.png')
        background-size 100% 100%
        position relative
        margin: 0 0.25rem
        .card
          position absolute
          width: 1.06rem;
          left: 0.16rem;
          bottom: 0.25rem;
          background-size 100% 100%
          &_1
            height 1.92rem;
            background-image: url('../images/card/1.png');
          &_2
            height 1.83rem;
            background-image: url('../images/card/2.png');
          &_3
            height 1.87rem;
            background-image: url('../images/card/3.png');
          &_4
            height 1.88rem;
            background-image: url('../images/card/4.png');
          &_5
            height 1.84rem;
            background-image: url('../images/card/5.png');
          &_6
            height 1.86rem;
            background-image: url('../images/card/6.png');
          &_7
            height 1.82rem;
            background-image: url('../images/card/7.png');
          &_8
            height 1.88rem;
            background-image: url('../images/card/8.png');
          &_9
            height 1.88rem;
            background-image: url('../images/card/9.png');
          &_10
            height 1.84rem;
            background-image: url('../images/card/10.png');
          &_11
            height 1.85rem;
            background-image: url('../images/card/11.png');
          &_12
            height 1.85rem;
            background-image: url('../images/card/12.png');
          &_13
            height 1.83rem;
            background-image: url('../images/card/13.png');
          &_14
            height 1.83rem;
            background-image: url('../images/card/14.png');
          &_15
            height: 1.84rem;
            background-image: url('../images/card/15.png');
          &_16
            height 1.89rem;
            background-image: url('../images/card/16.png');
          &_17
            height 1.89rem;
            background-image: url('../images/card/17.png');
          &_18
            height 1.92rem;
            background-image: url('../images/card/18.png');
          &_19
            height 1.93rem;
            background-image: url('../images/card/19.png');
          &_20
            height 1.85rem;
            background-image: url('../images/card/20.png');
    .confirm
      position absolute
      width: 2.25rem;
      height: 0.77rem;
      left: 2.62rem;
      top: 6.64rem;
      background-image url('./images/confirm.png')
      background-size 100% 100%
    .close
      position absolute
      width 0.73rem;
      height 0.73rem;
      background-image url('../images/close.png')
      background-size 100% 100%
      top 0;
      right 0.21rem;
</style>
